export default "__VITE_ASSET__87b92891__"